<template>
  <div class="guides">
    <div class="container fade pt-5 show active">
      <div class="row">
        <!-- Sticky sidebar -->
        <div id="stickyBlockStartPoint" class="col-lg-3 pr-xl-5 mb-5 mb-lg-0">
          <!-- Filter -->
          <div
            class="js-sticky-block"
            data-hs-sticky-block-options="{
              &quot;parentSelector&quot;: &quot;#stickyBlockStartPoint&quot;,
              &quot;breakpoint&quot;: &quot;lg&quot;,
              &quot;startPoint&quot;: &quot;#stickyBlockStartPoint&quot;,
              &quot;endPoint&quot;: &quot;#stickyBlockEndPoint&quot;,
              &quot;stickyOffsetTop&quot;: 16
              }"
          >
            <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
              <!-- Responsive Toggle Button -->
              <button v-b-toggle.providerReadmeNav class="navbar-toggler btn btn-block border py-3" aria-label="Toggle navigation">
                <span class="d-flex justify-content-between align-items-center">
                  <span class="h5 mb-0">{{ $t('M05d-02-mobile') }}</span>
                  <span class="navbar-toggler-default">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z" />
                    </svg>
                  </span>
                  <span class="navbar-toggler-toggled">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
                    </svg>
                  </span>
                </span>
              </button>
              <!-- End Responsive Toggle Button -->
              <b-collapse id="providerBrandedReadmeNav" class="navbar-collapse">
                <div class="my-5 mt-lg-0">
                  <h5>{{ $t('M05D-02-01a') }}</h5>
                  <!-- Nav Link -->
                  <div class=" overview-container">
                    <a class="dropdown-item d-flex justify-content-between align-items-center px-0 cursor-pointer active">
                      {{ $t('M05D-02-01b') }}
                    </a>
                  </div>
                  <!-- End Nav Link -->
                </div>
                <div class="my-5 mt-lg-0">
                  <h5>{{ $t('M05D-02-02a') }}</h5>
                  <!-- Nav Link -->
                  <div class="apis-container pr-2">
                    <router-link
                      v-for="(item, index) in apis"
                      :id="`${item.api_short_id}-readme`"
                      :key="`${index}-${Date.now()}`"
                      data-gtm-att="ga-M05D-02-02b"
                      class="dropdown-item d-flex justify-content-between align-items-center px-0 cursor-pointer"
                      :to="{
                        name: 'api-info',
                        params: {
                          provider_name: $route.params.provider_name,
                          api_name: (formatString(item.api_name).concat(`-${item.api_short_id}`)).replace(/\-+/g, '-'),
                          tab_name: 'readme'
                        }
                      }"
                    >
                      {{ item.api_name }}<i class="fas text-right readme-icons fa-chevron-right ml-2" />
                    </router-link>
                  </div>
                  <!-- End Nav Link -->
                </div>
                <div v-if="providerInfo[0] && (providerInfo[0].terms_of_use_url || providerInfo[0].privacy_policy_url)" class="mt-5 mt-lg-0">
                  <h5>{{ $t('M05D-02-03a') }}</h5>
                  <div class="others-container">
                    <a
                      v-if="providerInfo[0] && providerInfo[0].terms_of_use_url"
                      class="dropdown-item d-flex justify-content-between align-items-center px-0 cursor-pointer"
                      :href="providerInfo[0].terms_of_use_url"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {{ $t('M05D-02-03b-01') }}<i class="far fa-external-link-alt text-right readme-icons" />
                    </a>
                    <a
                      v-if="providerInfo[0] && providerInfo[0].privacy_policy_url"
                      class="dropdown-item d-flex justify-content-between align-items-center px-0 cursor-pointer"
                      :href="providerInfo[0].privacy_policy_url"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {{ $t('M05D-02-03b-02') }}<i class="far fa-external-link-alt text-right readme-icons" />
                    </a>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
        <!-- End Sticky Sidebar -->

        <!-- Main Guides Section -->
        <div id="scroll-to-div" class="col-lg-9 mb-5 mb-lg-0 px-lg-0">
          <Readme ref="readme" :guides="guides" :lastUpdateDate="lastUpdateDate" from="provider" :themeColor="theme_color" :noInfoMessage="$t('err-specific-01-02')" />
        </div>
      </div>
      <!-- End Main Guides Section -->
      <div class="space-top-2" />

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint" />
    </div>
  </div>
</template>

<script>
const $ = require('jquery')
import HSStickyBlock from '@/assets/vendor/hs-sticky-block/src/js/hs-sticky-block'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import Readme from '@/components/readme'
import providerInfoMixin from '@/mixins/provider-info'

export default {
  name: 'ProviderInfoGuides',
  components: {
    Readme
  },
  mixins: [providerInfoMixin],
  props: {
    guides: {
      type: String,
      default: ''
    },
    lastUpdateDate: {
      type: String,
      default: ''
    },
    apis: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentSection: 'how-it-works',
      headings: [],
      theme_color: '#57ABF0',
      loaded: false
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  watch: {
    async userProfile() {
      if (this.userProfile.id !== '') {
        this.initialise()
      }
    },
    apis: {
      deep: true,
      handler() {
        console.log(this.apis)
      }
    },
    loaded() {
      if (this.loaded) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$router.currentRoute.hash !== '') {
              this.$router.push({
                name: 'provider-info',
                params: {
                  provider_name: this.$route.params.provider_name,
                  tab_name: this.$route.params.tab_name
                },
                hash: this.$route.hash
              })
              this.scrollToSection(this.$router.currentRoute.hash.replace('#', ''))
            }
          })
        })
      }
    }
  },
  mounted() {
    new HSStickyBlock($('.js-sticky-block')).init()
    new HSGoTo($('.js-go-to')).init()
  },
  async created() {
    this.initialise()
  },
  methods: {
    initialise() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      this.$nextTick(() => {
        // ensure #providerBrandedReadmeNav is rendered
        const mediaQuery = window.matchMedia('(min-width: 992px)')
        if (mediaQuery.matches) {
          const i = document.querySelector('#providerReadmeNav').offsetHeight
          document.querySelector('#scroll-to-div').style.minHeight = `${i + 1}px`
        }
      })
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    scrollToSection(elementID) {
      document.getElementById(elementID) !== null ? document.getElementById(elementID).scrollIntoView({ behavior: 'smooth' }) : null
    },
    formatString(string) {
      return string.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').replace(/\-+/g, '-')
    }
  }
}
</script>

<style lang="scss" scoped>
.apis-container {
  max-height: 600px;
  overflow-y: hidden;
  &:hover {
    overflow-y: auto;
  }
  .dropdown-item {
    white-space: normal;
  }
}
.readme-icons {
  font-size: 10px;
}
a:not(href):hover, a:not(href).active, .endpoint-link{
  color: #57abf0;
}
a:not(href).active {
  font-weight: 600;
}
</style>
